import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  card: {
    display: 'flex',
    padding: '12px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    alignSelf: 'stretch',
  },
  cardTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  clickable: {
    cursor: 'pointer',
  },
  cardTitle: {
    fontWeight: 500,
    fontSize: 14,
    color: theme.palette.select.light,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '20px',
  },
  chevronButton: {
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    borderRadius: 8,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  cloudLogo: {
    height: 24,
    width: 'auto',
  },
  cloudLogoMicrosoft: {
    height: theme.spacing(2),
    width: theme.spacing(2),
  },
  divider: {
    height: 1,
    background: theme.palette.divider,
    width: '100%',
  },

  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    minHeight: '52px',
    width: '100%',
  },

  linkIcon: {
    color: theme.palette.select.light,
    display: 'inline-flex',
    alignItems: 'center',
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    padding: theme.spacing(0),
    borderRadius: 4,
  },
  copyLinkIcon: {
    color: theme.palette.select.light,
    display: 'inline-flex',
    alignItems: 'center',
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    borderRadius: 4,
    padding: theme.spacing(0),
  },
  chevronIcon: {
    transform: 'none',
    transition: 'transform 120ms ease',
  },
  chevronIconCollapsed: {
    transform: 'rotate(180deg)',
    transition: 'transform 120ms ease',
  },
  copyLinkIconTooltip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))
